import React from 'react';
import { Navigation } from './Navigation';
import { Samples } from './Samples';

const SamplesPage = () => {
  return (
    <div>
      <Navigation />
      <Samples />
    </div>
  );
};

export default SamplesPage;
